// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

//JS sur la home
const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    //Hover Newsthread
    document.addEventListener("DOMContentLoaded", function() {
        var newsthreadSwiper = document.querySelector(".newsthread__swiper");
        var newsthreadContent = newsthreadSwiper.closest(".newsthread__content");
    
        newsthreadSwiper.addEventListener("mouseenter", function() {
            newsthreadContent.classList.add("hover");
        });
    
        newsthreadSwiper.addEventListener("mouseleave", function() {
            newsthreadContent.classList.remove("hover");
        });
    });
    
}